module.exports = __webpack_public_path__ + "img/冬虫夏草.bce18980.jpg";